
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deep-learning-live-course",
      function () {
        return require("private-next-pages/deep-learning-live-course.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deep-learning-live-course"])
      });
    }
  